import React from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Layout from "../../../components/Layout/Layout";

export default function CampaignDetails() {
  const { code } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [campaign, setCampaign] = React.useState(location.state || null);

  // Mock data for fallback lookup
  const allCampaigns = [
    {
      code: "FREE7",
      title: "Thanks For Listening! Enjoy A Commission Free Week!",
      type: "Free Commission",
      duration: 7,
      roi: 50,
      totalRev: 9999,
    },
    {
      code: "SUMMER50",
      title: "Summer Sale 50% Discount",
      type: "Discount",
      duration: 30,
      roi: 45,
      totalRev: 125000,
    },
  ];

  React.useEffect(() => {
    // If campaign is missing (e.g. on refresh), find it by code
    if (!campaign && code) {
      const found = allCampaigns.find((c) => c.code === code);
      if (found) {
        setCampaign(found);
      } else {
        console.warn("No campaign found for code:", code);
      }
    }
  }, [campaign, code]);

  if (!campaign) {
    return (
      <Layout>
        <Box sx={{ p: 4 }}>
          <Typography sx={{ textAlign: "center", mt: 10 }}>
            Loading campaign details or campaign not found.
          </Typography>
          <Button sx={{ mt: 2 }} onClick={() => navigate(-1)}>
            Go Back
          </Button>
        </Box>
      </Layout>
    );
  }

  // Mock user list who used the code
  const users = [
    { name: "John Doe", joined: "2024-09-01", revenue: 250 },
    { name: "Jane Smith", joined: "2024-09-05", revenue: 150 },
    { name: "Mike Ross", joined: "2024-09-09", revenue: 350 },
  ];

  return (
    <Layout>
      <Box sx={{ p: 4 }}>
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
          {campaign.title}
        </Typography>
        <Typography sx={{ color: "#555", mb: 3 }}>
          Code: <b>{campaign.code}</b> — Type: <b>{campaign.type}</b>
        </Typography>

        <Paper sx={{ p: 2, borderRadius: 2, mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Campaign Details
          </Typography>
          <Typography>Duration: {campaign.duration} days</Typography>
          <Typography>ROI: {campaign.roi}%</Typography>
          <Typography>Total Revenue: ${campaign.totalRev}</Typography>
        </Paper>

        <Typography variant="h6" sx={{ mb: 2 }}>
          Users who used this code
        </Typography>

        <Table component={Paper}>
          <TableHead>
            <TableRow>
              <TableCell>User</TableCell>
              <TableCell>Joined On</TableCell>
              <TableCell>Revenue ($)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((u, i) => (
              <TableRow key={i}>
                <TableCell>{u.name}</TableCell>
                <TableCell>{u.joined}</TableCell>
                <TableCell>{u.revenue}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <Button
            variant="outlined"
            sx={{ mt: 3 }}
            onClick={() => {
              if (window.history.state && window.history.state.idx > 0) {
                navigate(-1);
              } else {
                navigate("/SignupCodes"); // fallback route (adjust as needed)
              }
            }}
          >
            Back
          </Button>

      </Box>
    </Layout>
  );
}
